import React from 'react';
import IndexTableRow from '../../../shared/index/table_row';
import PeopleTitleCell from './cells/title';
import LastModifiedCell from '../../../shared/index/last_modified_cell';
import {
  AverageScoreCell,
  RecentActivityCell,
  LastCompletedCell,
} from './cells/stats_cells';

const PeopleRow = props => (
  <IndexTableRow index={props.index} selectable={props.selectable}>
    <PeopleTitleCell {...props} />
    <LastModifiedCell lastModified={props.lastModified} />
    <AverageScoreCell averageScore={props.stats.averageScore} />
    <RecentActivityCell {...props.stats} />
    <LastCompletedCell {...props.stats} />
  </IndexTableRow>
);

export default PeopleRow;
